/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticValueShelfItem,
  AnimaticValueShelfItem$inboundSchema,
  AnimaticValueShelfItem$Outbound,
  AnimaticValueShelfItem$outboundSchema,
} from "./animaticvalueshelfitem.js";
import {
  ConditionExpression,
  ConditionExpression$inboundSchema,
  ConditionExpression$Outbound,
  ConditionExpression$outboundSchema,
} from "./conditionexpression.js";

/**
 * A single state for the value.
 */
export type AnimaticValueStateConfig = {
  /**
   * Defines a condition expression. Can be a single condition, a group of conditions, or nested groups. Exactly one of 'condition', 'condition_group', or 'nested_expression' must be specified.
   */
  conditionExpression?: ConditionExpression | undefined;
  /**
   * The configuration of the shelf item.
   */
  config: AnimaticValueShelfItem;
  /**
   * Whether this state is the default state. If this is true, conditions are not required. For readability, these states should be at the end of the array.
   */
  isDefault?: boolean | undefined;
  /**
   * The priority of the state. There is no constraint on overlapping conditions, so this field allows user to set priority.
   */
  priority?: number | undefined;
  /**
   * The name of the state
   */
  stateName: string;
};

/** @internal */
export const AnimaticValueStateConfig$inboundSchema: z.ZodType<
  AnimaticValueStateConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  condition_expression: types.optional(ConditionExpression$inboundSchema),
  config: AnimaticValueShelfItem$inboundSchema,
  is_default: types.boolean().default(false),
  priority: types.number().default(0),
  state_name: types.string(),
}).transform((v) => {
  return remap$(v, {
    "condition_expression": "conditionExpression",
    "is_default": "isDefault",
    "state_name": "stateName",
  });
});
/** @internal */
export type AnimaticValueStateConfig$Outbound = {
  condition_expression?: ConditionExpression$Outbound | undefined;
  config: AnimaticValueShelfItem$Outbound;
  is_default: boolean;
  priority: number;
  state_name: string;
};

/** @internal */
export const AnimaticValueStateConfig$outboundSchema: z.ZodType<
  AnimaticValueStateConfig$Outbound,
  z.ZodTypeDef,
  AnimaticValueStateConfig
> = z.object({
  conditionExpression: ConditionExpression$outboundSchema.optional(),
  config: AnimaticValueShelfItem$outboundSchema,
  isDefault: z.boolean().default(false),
  priority: z.number().int().default(0),
  stateName: z.string(),
}).transform((v) => {
  return remap$(v, {
    conditionExpression: "condition_expression",
    isDefault: "is_default",
    stateName: "state_name",
  });
});

export function animaticValueStateConfigToJSON(
  animaticValueStateConfig: AnimaticValueStateConfig,
): string {
  return JSON.stringify(
    AnimaticValueStateConfig$outboundSchema.parse(animaticValueStateConfig),
  );
}
export function animaticValueStateConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticValueStateConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticValueStateConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticValueStateConfig' from JSON`,
  );
}
